/**
 * Created by ekst_aegg on 27.06.2016
 */
(function() {
    'use strict';

    var openClass = 'open',
        doneClass = 'done',
        availableClass = 'available',
        itemQuery = '.card-list-process-item',
        itemHeading = '.card-list-process-heading',
        itemBody = '.card-list-process-body';

    /* START Helper functions */
    var clickFilter = function(fn) {
        // Kaller fn dersom event er av typen click eller keyCode 13
        return function(e) {
            if (e.type === 'click' || e.keyCode == 13) {
                fn(e);
            }
        };
    };
    var forEach = function (object) {
        return function(cb) {
            Object.keys(object).forEach(function(key) {
                cb(key, object[key]);
            });
        };
    };
    var createItemWrapper = function(el) {
        return {
            el: el,
            done: false
        };
    };
    /* END Helper functions */

    //Lighter, patent pending 
    var Lighter = function(item) {
        if (!(this instanceof Lighter)) {
            return new Lighter(item);
        }

        if (typeof item === 'string') {
            this.item = document.querySelector(item);
        } else {
            this.item = item;
        }
        return this;
    };
    Lighter.prototype = {
        hasClass: function(klass) {
            if (this.item.classList) {
                return this.item.classList.contains(klass);
            } else {
                return this.item.className.split(' ').indexOf(klass) > -1;
            }
        },
        getEl: function() {
            return this.item;
        },
        child: function(selector) {
            if (!selector) {
                return this;
            }
            return Lighter(this.item.querySelector(selector));
        },
        parent: function() {
            return Lighter(this.item.parentElement);
        },
        addClass: function(klass) {
            if (this.item.classList) {
                this.item.classList.add(klass);
            } else if (!this.hasClass(klass)) {
                this.item.className += ' ' + klass;
            }
            return this;
        },
        removeClass: function(klass) {
            if (this.item.classList) {
                this.item.classList.remove(klass);
            } else if (this.hasClass(klass)) {
                var items = this.item.className.split(' ');
                items.splice(items.indexOf(klass), 1);
                this.item.className = items.join(' ');
            }
            return this;
        },
        getRealHeight: function() {
            this.css({
                visibility: 'hidden',
                height: 'auto'
            });

            var realHeight = this.item.offsetHeight;

            this.css({
                visibility: '',
                height: '0'
            });
            // Trigger redraw before changing
            this.item.offsetHeight;  // jshint ignore:line
            return realHeight;
        },
        attr: function(key, value) {
            if(value === undefined){
                this.item.getAttribute(key);
            }
            else {
                this.item.setAttribute(key, value);
            }
            return this;
        },
        css: function(prop, value) {
            if (typeof prop === 'object') {
                forEach(prop)(this.css.bind(this));
            } else if (value) {
                this.item.style[prop] = value;
            } else {
                return this.item.style[prop];
            }
            return this;
        }
    };

    var Progress = function(el) {
        this.el = el;
        var items = el.querySelectorAll(itemQuery);
        this.items = Array.prototype.map.call(items, function(it) {
            return createItemWrapper(it);
        });
    };
    Progress.prototype = {
        open: function(index) {
            if (this.currentOpenIndex !== index) {

                this.close();

                this.currentOpenIndex = index;

                var item = this.items[this.currentOpenIndex];
                if (!item) {
                    return;
                }
                var el = Lighter(item.el);
                var body = el.child(itemBody);
                var header = el.child(itemHeading);

                var height = body.getRealHeight();
                var bodyEl = body.getEl();

                //Shame we have to do this.. 
                var transitionEnd = function() {
                    body.css('height', 'auto');
                    bodyEl.removeEventListener('transitionend', transitionEnd, false);
                };

                if ('transition' in bodyEl.style) {
                    bodyEl.addEventListener('transitionend', transitionEnd, false);
                } else {
                    setTimeout(transitionEnd, 500);
                }

                body.css({
                    height: height + 'px',
                    visibility: 'visible'
                });

                body.attr('aria-hidden', false);
                header.attr('aria-expanded', true);
                el.removeClass(availableClass).addClass(openClass);
            }
        },
        close: function() {
            if (this.currentOpenIndex === undefined || this.currentOpenIndex === -1) {
                return;
            }

            var item = this.items[this.currentOpenIndex];
            var itemEl = Lighter(item.el);
            var body = itemEl.child(itemBody);
            var header = itemEl.child(itemHeading);

            var bodyEl = body.getEl();

            var realHeight = bodyEl.offsetHeight;

            body.css('height', realHeight + 'px');

            //Force Redraw..
            bodyEl.offsetHeight; // jshint ignore:line

            var onTransitionEnd = function(){
                body.attr('aria-hidden', true);
                header.attr('aria-expanded', false);
                itemEl.removeClass(openClass);

                //Add classes as needed
                if(item.done){
                    itemEl.addClass(doneClass);
                }
                if(item.available){
                    itemEl.addClass(availableClass);
                }

                bodyEl.removeEventListener('transitionend', onTransitionEnd, false);
                bodyEl.removeEventListener('webkitTransitionEnd', onTransitionEnd, false);
            };

            if('transition' in bodyEl.style){
                bodyEl.addEventListener('transitionend', onTransitionEnd, false);
                bodyEl.addEventListener('webkitTransitionEnd', onTransitionEnd, false);
            } else {
                setTimeout(onTransitionEnd, 500);
            }

            body.css({
                height: '0px',
                visibility: 'hidden'
            });

            itemEl.removeClass(openClass);

            this.currentOpenIndex = '';
        },
        resetAvailable: function() {
            var current = this.currentOpenIndex,
                i = current + 1,
                l = this.items.length;

            for (; i < l; i++) {
                this.items[i].done = false;
                this.items[i].available = false;
                Lighter(this.items[i].el).removeClass(doneClass).removeClass(availableClass);
            }
        },
        resetDone: function() {
            var current = this.currentOpenIndex,
                i = 0,
                l = current;

            for (; i < l; i++) {
                this.items[i].done = true;
                this.items[i].available = false;
                Lighter(this.items[i].el).addClass(doneClass);
            }
        },
        makeAvailable: function(index) {
            var current = index || this.currentOpenIndex,
                i = 0,
                l = current;

            for (; i < l; i++) {
                this.items[i].done = true;
                this.items[i].available = true;
                Lighter(this.items[i].el).addClass(doneClass).addClass(availableClass);
            }
        },
        goTo: function(next, validator) {
            if (!(this.currentOpenIndex === undefined || this.currentOpenIndex === -1)) {
                var item = this.items[this.currentOpenIndex],
                    currentEl = Lighter(item.el);
                if (typeof validator === 'function') {
                    if (!validator(item.el, this.currentOpenIndex, next)) {
                        return false;
                    }
                    item.done = true;
                }
                else if(validator === true){
                    item.done = true;
                }
                item.available = true;
            }

            this.open(next);
        },
        isAvailable: function(itemIndex) {
            var item = this.items[itemIndex];
            return item && item.available;
        },
        bind: function(validation) {
            //Validation is called with currentEl, currentIndex, futureIndex
            var _this = this,
                validator = validation,
                l = this.items.length,
                i = 0;

            this.eventListener = function(e) {
                var curr = Lighter(e.target);
                var parent = curr.parent();
                if (curr.hasClass('progress-next') || parent.hasClass('progress-next')) {
                    _this.goTo(_this.currentOpenIndex + 1, validator);
                }
                if (curr.hasClass('list-group-item-heading') || parent.hasClass('list-group-item-heading')) {
                    var selectable = parent.hasClass('can-expand') ? parent : parent.parent();
                    if (selectable.hasClass('can-expand') && (selectable.hasClass(doneClass) || selectable.hasClass(availableClass))) {
                        var nextIndex,
                            i = 0,
                            l = _this.items.length;
                        for (; i < l; i++) {
                            if (_this.items[i].el === selectable.getEl()) {
                                nextIndex = i;
                                break;
                            }
                        }
                        _this.goTo(nextIndex);
                    }
                }
            };

            this.el.addEventListener('keypress', clickFilter(this.eventListener), false);
            this.el.addEventListener('click', this.eventListener, false);
        },
        unbind: function() {
            this.el.removeEventListener('keypress', clickFilter(this.eventListener), false);
            this.el.removeEventListener('click', this.eventListener, false);
        }
    };


    window.eikamodules = window.eikamodules || {};

    window.eikamodules.Progress = Progress;

})();